module.exports = __webpack_public_path__ + "static/media/sup.390bb692.png";